// Compact "we accept" row to render INSIDE the Add Card form (next to Square's tokenize iframe).
// Smaller than the page-footer PaymentLogos strip.

export default function CardLogosRow({ className = "" }) {
  return (
    <div className={`flex items-center gap-1.5 flex-wrap ${className}`} data-testid="card-logos-row">
      <span className="text-[9px] uppercase tracking-[0.25em] text-zinc-500 mr-1">Accepted:</span>
      <span className="h-5 px-1.5 rounded bg-white border border-zinc-300 flex items-center" aria-label="Visa">
        <span className="text-[10px] font-extrabold italic" style={{ color: "#1A1F71" }}>VISA</span>
      </span>
      <span className="h-5 w-7 rounded bg-white border border-zinc-300 flex items-center justify-center" aria-label="Mastercard">
        <span className="relative w-4 h-3 inline-block">
          <span className="absolute left-0 top-0 h-3 w-3 rounded-full bg-[#EB001B]"/>
          <span className="absolute right-0 top-0 h-3 w-3 rounded-full bg-[#F79E1B] mix-blend-multiply"/>
        </span>
      </span>
      <span className="h-5 px-1.5 rounded flex items-center" style={{ backgroundColor: "#016FD0" }} aria-label="American Express">
        <span className="text-[9px] font-extrabold text-white tracking-wider">AMEX</span>
      </span>
      <span className="h-5 px-1.5 rounded flex items-center" style={{ backgroundColor: "#FF6000" }} aria-label="Discover">
        <span className="text-[9px] font-extrabold text-white tracking-wider">DISCOVER</span>
      </span>
      <span className="h-5 px-1.5 rounded bg-zinc-950 border border-zinc-700 flex items-center" aria-label="Apple Pay">
        <span className="text-[10px] font-bold text-white"> Pay</span>
      </span>
      <span className="h-5 px-1.5 rounded bg-white border border-zinc-300 flex items-center" aria-label="Google Pay">
        <span className="text-[10px] font-bold text-zinc-700">G Pay</span>
      </span>
    </div>
  );
}
